import { AceEditorField, CheckboxV2Field } from 'lib/iterable-hook-form/FormField';
import { useWatch } from 'react-hook-form';
import styled from 'styled-components';
import { body2, spacing } from 'ui/theme';
import { JourneyTestingFormSchemaType } from './JourneyTestingModalFormProvider';
import { ADD_SAMPLE_TRIGGER_EVENT, SAMPLE_TRIGGER_EVENT_DATA } from './constants';

const AceEditorWrapper = styled.div`
  .ace_comment.ace_placeholder {
    ${body2}
    margin: ${spacing.base} 0 0 0;
  }
`;

const FormSubsection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

const content = {
  editorContent:
    'Example: If your journey is triggered when a customer \nmakes a purchase of $100, you could enter: \n { \n   "ChargeAmount":100 \n }',
};

export const SampleTriggerEvent = () => {
  const addSampleTriggerEvent = useWatch<JourneyTestingFormSchemaType>({
    name: ADD_SAMPLE_TRIGGER_EVENT,
  });

  return (
    <FormSubsection>
      <CheckboxV2Field name={ADD_SAMPLE_TRIGGER_EVENT} label="Add sample trigger event" />
      {addSampleTriggerEvent && (
        <AceEditorWrapper>
          <AceEditorField
            name={SAMPLE_TRIGGER_EVENT_DATA}
            height="152px"
            mode="json"
            wrapEnabled
            placeholder={content.editorContent}
          />
        </AceEditorWrapper>
      )}
    </FormSubsection>
  );
};
